import { API_URL, fetchWithHandling } from './api';

// ---------------------------------------------------------------------------
// Agent questions API
//
// Open questions of the meeting and mail pipelines that the member may
// answer, each a 1:1 chat with the agent (the Waiting tab). Responses are the
// AppResponse envelope; failures throw { code, message }.
// ---------------------------------------------------------------------------

const BASE = `${API_URL}/api/agent-questions`;

const auth = (accessToken) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${accessToken}`,
});

const questionUrl = (id) => `${BASE}/${encodeURIComponent(id)}`;

/**
 * { data: [{ id, source, title, question, context, about, options, urgency,
 * unsure, transferred_by, replies, updated_at }] }
 */
export async function listQuestions(accessToken) {
  return fetchWithHandling(BASE, { method: 'GET', headers: auth(accessToken) });
}

/**
 * { data: { question, status: open|answered|closed, messages: [{ role, text, at }],
 * history: [{ action, by: { user_id, name }, to?, resolution?, at }] } }
 */
export async function getQuestionThread(accessToken, id) {
  return fetchWithHandling(questionUrl(id), {
    method: 'GET',
    headers: auth(accessToken),
  });
}

/** The member's reply; the thread comes back, `answered` when it was one. */
export async function replyToQuestion(accessToken, id, text) {
  return fetchWithHandling(`${questionUrl(id)}/reply`, {
    method: 'POST',
    headers: auth(accessToken),
    body: JSON.stringify({ text }),
  });
}

/** Hide it from the member's list; it stays open for others. */
export async function closeQuestion(accessToken, id) {
  return fetchWithHandling(`${questionUrl(id)}/close`, {
    method: 'POST',
    headers: auth(accessToken),
  });
}

/** { data: [{ user_id, name, email }] }: everyone else in the project. */
export async function listTransferTargets(accessToken, id) {
  return fetchWithHandling(`${questionUrl(id)}/transfer-targets`, {
    method: 'GET',
    headers: auth(accessToken),
  });
}

/** Pass the question to another member; it leaves the caller's list. */
export async function transferQuestion(accessToken, id, userId) {
  return fetchWithHandling(`${questionUrl(id)}/transfer`, {
    method: 'POST',
    headers: auth(accessToken),
    body: JSON.stringify({ user_id: userId }),
  });
}
